module.exports = __webpack_public_path__ + "static/img/outstanding.1a97440.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/outstanding.svg
// module id = /73v
// module chunks = 4